import formatQueryString from '../../../../utils/formatQueryString';

export default (params): string => `/cp/api/feed-items?${formatQueryString(params)}`;
